export default "__VITE_ASSET__aUcK1BRT__"